import Vue from 'vue'
import api from '../../api'
import store from '@/store'
import { NavigationGuard } from 'vue-router'

const loadPortalCache = (comCode: string, personCode: string, version: account.TCacheVersion): Promise<any> => {
    return Promise.all([
        api.cache.loadMenuCache(comCode, version.menu || 0),
        api.cache.loadQuickMenuCache(comCode, version.quickMenu || 0),
        // api.cache.loadWebpartCache(comCode, ver.webpart || 0),
        api.cache.loadWebpartCacheV3(comCode, version.webpartV3 || 0),
        api.cache.loadTemplateCacheV3(
            comCode,
            version.webpartV3Template || 0
        ),
        api.cache.loadPersonalCacheV3(
            comCode,
            personCode,
            version.webpartV3Personal || 0
        )
    ]).then(res => {
        const [ menu, quick, webpartsv3, templates, personal ] = res;
        const cache: appbase.cache.TPortalCache = {
            menu,
            quick,
            // webparts,
            webpartsv3: new WebpartHelper(webpartsv3, templates, personal),
        }
        Vue.prototype.portalCache = {
            ...Vue.prototype.portalCache,
            ...cache,
        }

        return res;
    })
}

class WebpartHelper implements appbase.cache.IWebpartV3Model {
    webparts: appbase.cache.TWebpartV3[] | null
    templates: appbase.cache.TWebpartV3Template[] | null
    personal: appbase.cache.TWebpartV3Template | null
    current: account.TCurrent | null

    constructor(
        webparts: appbase.cache.TWebpartV3[] | null,
        templates: appbase.cache.TWebpartV3Template[] | null,
        personal: appbase.cache.TWebpartV3Template | null
    ) {
        this.webparts = webparts
        this.templates = templates
        this.personal = personal
        this.current = store.state.$account!.current
    }

    getPrivilegedWebparts(): Promise<appbase.cache.TWebpartV3[]> {
        return new Promise((resolve, reject) => {
            const { current, webparts } = this
            if (!current)
                throw new Error(
                    'INVALID_OPERATION_ERROR : No login information.'
                )

            console.log('getPrivilegedWebparts', webparts)
            if(webparts) {
                // 로그인 정보에서 나에게 권한이 있는 아이디 목록 조회
                const { webparts: ids } = current.permissions
                // 로드한 캐시에서 해당 아이디를 가지는 목록을 추출
                const privailegedWebparts = webparts.filter((x) =>
                    ids.includes(x.id)
                )
                console.log('privailegedWebparts', privailegedWebparts)
                resolve(privailegedWebparts)
            } else {
                resolve([])
            }
        })
    }

    getPrivilegedTemplates(): Promise<appbase.cache.TWebpartV3Template[]> {
        return new Promise((resolve, reject) => {
            const { current, templates } = this
            if (!current)
                throw new Error(
                    'INVALID_OPERATION_ERROR : No login information.'
                )

            if(templates) {
                // 로그인 정보에서 나에게 권한이 있는 아이디 목록 조회
                const { webpartTemplates: ids } = current.permissions
                // 로드한 캐시에서 해당 아이디를 가지는 목록을 추출
                const privailegedTemplates = templates.filter((x) =>
                    ids.includes(x.id)
                )
                console.log('privailegedTemplates', privailegedTemplates)
                resolve(privailegedTemplates)
            } else {
                resolve([])
            }
        })
    }

    getMyTemplate(cache: boolean = true): Promise<appbase.cache.TWebpartV3Template> {
        return new Promise(async (resolve, reject) => {
            if (cache && this.personal) {
                resolve(this.personal)
            } else {
                const templates = await this.getPrivilegedTemplates()
                const template = templates[0]
                resolve(template)
            }
        })
    }
}

const PortalCacheGuard: NavigationGuard = async (to, from, next) => {
    console.log(`Evaluating ${PortalCacheGuard.name}...`)
    const current = (store.state as any).$account?.current as
        | account.TCurrent
        | null
        | undefined
    if (current) {
        const { comCode, personCode } = current.user;
        const ver = current.cacheVersion;
        
        await loadPortalCache(comCode, personCode, ver);        
        next()
    } else {
        throw new Error(
            `[INVALID_OPERATION_ERROR] ${PortalCacheGuard.name} : store.state.$account is not initialized.`
        )
    }
}

export default PortalCacheGuard
